import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, inject, input, output, resource } from "@angular/core";

import { HealthStatus, IotnetGateway } from "../../../apis/stats/rest/models";
import { IOTNET_REPOSITORY } from "../../../pages/iotnet/iotnet-repository.port";
import { ServiceTags } from "../../subscriptions-list/service-tags/service-tags";
import { IotnetGatewayCaption } from "../iotnet-gateway-caption/iotnet-gateway-caption";
import { gatewayTags } from "../iotnet-gateway-tags";
import { IotnetGatewayTrafficChart } from "../iotnet-gateway-traffic-chart/iotnet-gateway-traffic-chart";

@Component({
  selector: "iotnet-gateway-detail",
  templateUrl: "iotnet-gateway-detail.html",
  styleUrls: ["./iotnet-gateway-detail.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, IotnetGatewayCaption, IotnetGatewayTrafficChart, ServiceTags, TranslatePipe],
})
export class IotnetGatewayDetail {
  public readonly gateway = input.required<IotnetGateway>();
  public readonly customerId = input.required<string>();
  public readonly closed = output<void>();

  private readonly iotnet = inject(IOTNET_REPOSITORY);

  protected readonly tags = computed(() => gatewayTags(this.gateway()));
  protected readonly health = resource({
    params: () => ({ customer_id: this.customerId(), gateway_id: this.gateway().gateway_id }),
    loader: ({ params }) => this.iotnet.getIotnetGatewayHealth(params),
  });
  protected readonly healthStatus = computed(() => {
    if (this.health.isLoading() || !this.health.hasValue()) return HealthStatus.Unknown;
    else return this.health.value().status;
  });

  protected readonly currentRates = computed(() => {
    if (this.health.isLoading() || !this.health.hasValue()) return null;
    const record = this.health.value();
    const format = (packetsPerSecond: number) => `${Math.round(packetsPerSecond).toLocaleString()} pps`;
    return { in: format(record.in), out: format(record.out) };
  });

  protected close(): void {
    this.closed.emit();
  }
}
